import React, { Fragment } from 'react';
import { connect } from '../../redux/store';
import { compose, withHandlers } from 'recompose';
import {
  openModalForm,
  selectServicesKapp,
  C,
} from '@kineticdata/bundle-common';
import { I18n } from '@kineticdata/react';

export const RequestShowConfirmation = ({ handleOpenFeedback }) => (
  <Fragment>
    <div className="h5">
      <I18n>Thank you for your submission.</I18n>
    </div>
    <div>
      <I18n>With</I18n>{' '}
      <button className="btn btn-text font-weight-bold" onClick={handleOpenFeedback}>
        <I18n>Feedback</I18n>
      </button>{' '}
      <I18n>we are able to continuously improve.</I18n>
    </div>
  </Fragment>
);

const enhance = compose(
  connect(state => ({ servicesKapp: selectServicesKapp(state) })),
  withHandlers({
    handleOpenFeedback: props => () =>
      openModalForm({
        ...C.FEEDBACK_FORM_CONFIG,
        kappSlug: props.servicesKapp && props.servicesKapp.slug,
        values: {
          [C.FIELD_REFERRING_ID]: props.submission.id,
        },
        duration: 5000,
      }),
  }),
);

export const RequestShowConfirmationContainer = enhance(
  RequestShowConfirmation,
);
